import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './Yad2ContactLeadsTable.css';

const Yad2ContactLeadsTable = () => {
  const [leads, setLeads] = useState([]);

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const response = await axios.get('/api/contact-yad2');
        setLeads(response.data);
      } catch (error) {
        console.error('שגיאה בטעינת הנתונים:', error);
      }
    };

    fetchLeads();
  }, []);

  return (
    <div className="Yad2LeadsTableWrapper">
      <h2 className="Yad2LeadsTableTitle">פניות שהתקבלו</h2>
      <table className="Yad2LeadsTable">
        <thead>
          <tr>
            <th>שם</th>
            <th>טלפון</th>
            <th>סוג רכב</th>
            <th>הודעה</th>
            <th>תאריך</th>
          </tr>
        </thead>
        <tbody>
          {leads.map((lead) => (
            <tr key={lead.id}>
              <td>{lead.name}</td>
              <td>{lead.phone_number}</td>
              <td>{lead.car_type}</td>
              <td>{lead.message}</td>
              <td>{new Date(lead.submitted_at).toLocaleString('he-IL')}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Yad2ContactLeadsTable;
